import { v4 } from 'uuid';

const initialState = {
  user: null,
  updating: false,
};

const update = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_AUTHORIZATION_USER':
      return {
        ...state,
        user: action.user || { uuid: v4(), userId: '', permissions: [], groups: [] },
      };

    case 'CANCEL_UPDATE_AUTHORIZATION_USER':
      return initialState;

    case 'UPDATE_SET_AUTHORIZATION_USER_ID':
      return {
        ...state,
        user: { ...state.user, userId: action.userId },
      };

    case 'UPDATE_SET_AUTHORIZATION_USER_PERMISSIONS':
      return {
        ...state,
        user: { ...state.user, permissions: action.permissions },
      };

    case 'UPDATE_SET_AUTHORIZATION_USER_GROUPS':
      return {
        ...state,
        user: { ...state.user, groups: action.groups },
      };

    case 'UPDATE_AUTHORIZATION_USER_REQUEST':
      return {
        ...state,
        updating: true,
      };

    case 'UPDATE_AUTHORIZATION_USER_SUCCESS':
      return initialState;

    case 'UPDATE_AUTHORIZATION_USER_FAILURE':
      return {
        ...state,
        updating: false,
      };

    default:
      return state;
  }
};

export default update;

export const getUser = (state) => state.user;

export const isUpdating = (state) => state.updating;
